import React, { useState, useCallback, useEffect } from 'react';
import Toolbar from 'src/components/Toolbar';
import { useTranslation } from 'react-i18next';
import GenderSelector from 'src/components/GenderSelector';
import DatePicker from 'src/components/InputDatePicker';
import Button from 'src/components/Button';
import { useHistory } from 'react-router-dom';
import TextInput from 'src/components/TextInput';
import NationSelector from 'src/components/NationSelector';
import PopupService from 'src/utils/PopupService';
import { VN_COUNTRY_CODE } from 'src/constants';
// import LoadingService from 'src/utils/LoadingService';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import UserInfoService from 'src/utils/UserInfoService';
import { isValidDate, confirmQuitFlow } from 'src/utils';
import InfoItem from 'src/components/InfoItem';
dayjs.extend(customParseFormat);

const YourInfoSpa = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [birthDate, setBirthDate] = useState(
    UserInfoService.getUserInfo()?.dob != null &&
      isValidDate(UserInfoService.getUserInfo()?.dob, t('date_format2'))
      ? dayjs(UserInfoService.getUserInfo()?.dob, t('date_format2')).toDate()
      : null
  );
  const [errBirthDate, setErrBirthDate] = useState(null);
  const [gender, setGender] = useState(UserInfoService.getUserInfo()?.gender);
  const [errGender, setErrGender] = useState(null);
  const [nation, setNation] = useState(VN_COUNTRY_CODE);
  const [email, setEmail] = useState(UserInfoService.getUserInfo()?.email);
  const [errEmail, setErrEmail] = useState(null);
  const _handleChangeGender = (newGender) => {
    setGender(newGender);
    if (newGender) {
      setErrGender(null);
    }
  };

  const _handleChangeDay = useCallback((date) => {
    setBirthDate(date);
    setErrBirthDate(null);
  }, []);

  const _handleChangeNation = useCallback(
    (newNation) => {
      setNation(newNation);
    },
    [setNation]
  );

  const _handheChangeEmail = useCallback((event) => {
    setEmail(event.target.value);
    setErrEmail(null);
  }, []);

  // const _getNationName = useCallback(() => {
  //   if (!nation) return null;
  //   return nationList.find((item) => item.id == nation)?.name || null;
  // }, [nationList, nation]);

  const _handleContinue = () => {
    console.log('_handleContinue YourInfoSpa', birthDate);
    if (!birthDate) {
      setErrBirthDate(t('dob_required'));
      return;
    } else if (!gender) {
      setErrGender(t('gender_required'));
      return;
    } else if (nation != VN_COUNTRY_CODE) {
      PopupService.instance.current.open({
        visible: true,
        title: t('notification'),
        content: t('err_nation'),
        cancelTitle: t('later'),
        showContactButton: true,
        hotline: t('hotline2'),
        onOk: () => {
          PopupService.instance.current.close();
        },
        onCancel: () => {
          PopupService.instance.current.close();
        },
      });
      return;
    } else if (!email) {
      setErrEmail(t('email_required'));
      return;
    }
    history.push('/commitment_spa');
    // LoadingService.instance.current.open();
    // dispatch(
    //   requestCheckValidUserInfo(
    //     dayjs(birthDate).format(t('date_format1')),
    //     gender,
    //     _getNationName(),
    //     history
    //   )
    // );
  };

  // useEffect(() => {
  //   dispatch(requestCategory(ProductCode.CANCER));
  // }, [dispatch]);

  const _handleClose = () => {
    console.log('Handle close', history);
    confirmQuitFlow(history);
    // PopupService.instance.current.open({
    //   visible: true,
    //   title: t('notification'),
    //   content: t('confirm_quit_cancer'),
    //   okTitle: t('exit'),
    //   cancelTitle: t('stay'),
    //   onOk: () => {
    //     PopupService.instance.current.close();
    //     history.go(-(history.length - 2));
    //     history.push('/', { state: { isActive: true } });
    //   },
    //   onCancel: () => {
    //     PopupService.instance.current.close();
    //   },
    // });
  };
  return (
    <div className="screen-container bg-background">
      <Toolbar
        title={t('request_insurrance')}
        showClose={true}
        onClose={_handleClose}
      />
      <div className="max-w-md mx-auto screenScrollContainer">
        <div className="px-4 py-5 text-sm text-onSurfaceVariant">
          {t('request_insurrance_guide')}
        </div>
        <div className="bg-surface px-4 pt-6 pb-8">
          <div className="mb-5">
            <TextInput
              disabled={true}
              label={t('full_name_buyer')}
              value={UserInfoService.getUserInfo()?.fullname || ''}
            />
          </div>
          <div className="mb-5">
            <DatePicker
              label={t('dob_full')}
              placeholder={t('date_format1')}
              value={birthDate}
              onChange={_handleChangeDay}
              isRequired={true}
              error={!!errBirthDate}
              helperText={errBirthDate}
              maxDate={new Date()}
            />
          </div>
          <div className="mb-5">
            <GenderSelector
              value={gender}
              onChange={_handleChangeGender}
              isRequired={true}
              helperText={errGender}
              error={!!errGender}
            />
          </div>
          <div className="mb-5">
            <NationSelector
              isRequired={true}
              value={nation}
              onChange={_handleChangeNation}
            />
          </div>
          <div className="mb-5">
            <InfoItem
              title={t('identity_card_type')}
              content={UserInfoService.getUserInfo()?.idCardType}
            />
          </div>
          <div className="mb-5">
            <InfoItem
              title={t('identity_card_number')}
              content={UserInfoService.getUserInfo()?.idCardNo}
            />
          </div>
          <div className="mb-5">
            <InfoItem
              title={t('issued_date')}
              content={
                UserInfoService.getUserInfo()?.issueDate
                  ? dayjs(UserInfoService.getUserInfo()?.issueDate).format(
                      t('date_format1')
                    )
                  : ''
              }
            />
          </div>
          <div className="mb-5">
            <InfoItem
              title={t('issued_place')}
              content={UserInfoService.getUserInfo()?.issuePlace}
            />
          </div>
          <div className="mb-5">
            <InfoItem
              title={t('phone')}
              content={UserInfoService.getUserInfo()?.mobile}
            />
          </div>
          <div className="mb-5">
            <TextInput
              label={t('email')}
              placeholder={t('email_placeholder')}
              value={email}
              isRequired={true}
              onChange={_handheChangeEmail}
              error={!!errEmail}
              helperText={errEmail}
            />
          </div>
        </div>
      </div>
      <div className="bottomButtonBlock">
        <Button
          text={t('continue')}
          onClick={_handleContinue}
          extraClassName={'w-full'}
        />
      </div>
    </div>
  );
};

export default YourInfoSpa;
